import { useState, useEffect } from "react";
import styles from "./News.module.css";
import SubPageTop from "../components/SubPageTop";
import ScrollReveal from "../components/Ui/ScrollReveal";
import { useNavigate } from "react-router-dom";
import apiService from "../services/api"; 

export default function News() {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("notice");
    const [page, setPage] = useState(1);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [totalPages, setTotalPages] = useState(0);
    const itemsPerPage = 12;

    // 데이터 가져오기
    const fetchData = async () => {
        setLoading(true);
        setError(null);
        
        try {
            let response;
            if (activeTab === "notice") {
                response = await apiService.getNotices(page, itemsPerPage);
                const notices = response.notices || response || [];
                const formattedData = notices.map(notice => ({
                    id: notice.id,
                    title: notice.title,
                    date: notice.date ? new Date(notice.date).toLocaleDateString('ko-KR') : '날짜 없음',
                    img: notice.imageUrl || "/image/20160107000821_0.jpg"
                }));
                setData(formattedData);
                setTotalPages(Math.ceil((response.total || notices.length) / itemsPerPage));
            } else if (activeTab === "press") {
                response = await apiService.getPressList(page, itemsPerPage);
                const presses = response.presses || response || [];
                const formattedData = presses.map(press => ({
                    id: press.id,
                    title: press.title,
                    date: press.date ? new Date(press.date).toLocaleDateString('ko-KR') : '날짜 없음',
                    img: press.imageUrl || "/image/20160107000821_0.jpg"
                }));
                setData(formattedData);
                setTotalPages(Math.ceil((response.total || presses.length) / itemsPerPage));
            } else if (activeTab === "seminar") {
                response = await apiService.getSeminars(page, itemsPerPage);
                const seminars = response.seminars || response || [];
                const formattedData = seminars.map(seminar => ({
                    id: seminar.id,
                    title: seminar.title,
                    date: seminar.date ? new Date(seminar.date).toLocaleDateString('ko-KR') : '날짜 없음',
                    img: seminar.imageUrl || "/image/20160107000821_0.jpg"
                }));
                setData(formattedData);
                setTotalPages(Math.ceil((response.total || seminars.length) / itemsPerPage));
            }
        } catch (error) {
            console.error('데이터 가져오기 실패:', error);
            setError('데이터를 불러오는데 실패했습니다.');
            setData([]);
            setTotalPages(0);
        } finally {
            setLoading(false);
        }
    };

    // 탭 변경 시 데이터 다시 가져오기
    useEffect(() => {
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab, page]);
 
    // 현재 페이지 데이터
    const pagedData = data.slice(
        (page - 1) * itemsPerPage,
        page * itemsPerPage
    );

    // 탭 클릭 시 페이지 1로 초기화
    const handleTab = (tab) => {
        setActiveTab(tab);
        setPage(1);
    };

    if (loading) {
        return (
            <div className={styles.communityWrap}>
                <SubPageTop title="Community" />
                <div className={styles.SubPageWidth}>
                    <div className={styles.loading}>데이터를 불러오는 중...</div>
                </div>
            </div>
        );
    }

   if (error) {
        return (
            <div className={styles.communityWrap}>
                <SubPageTop title="Community" />
                <div className={styles.SubPageWidth}>
                    <div className={styles.error}>{error}</div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.communityWrap}>
            <SubPageTop title="News" subTitle="소식" backgroundColor="#A9A8E8" />
            <div className={styles.SubPageWidth}>
                <div className={styles.tabWrap}>
                    <button
                        type="button"
                        className={`${styles.tab} ${
                            activeTab === "notice" ? styles.active : ""
                        }`}
                        onClick={() => handleTab("notice")}
                    >
                        공지사항
                    </button>
                    <button
                        type="button"
                        className={`${styles.tab} ${
                            activeTab === "press" ? styles.active : ""
                        }`}
                        onClick={() => handleTab("press")}
                    >
                        언론보도
                    </button>
                    <button
                        type="button"
                        className={`${styles.tab} ${
                            activeTab === "seminar" ? styles.active : ""
                        }`}
                        onClick={() => handleTab("seminar")}
                    >
                        세미나 & 컨퍼런스
                    </button>
                </div>

                {/* 카드 리스트 */}
                <ScrollReveal>
                    <div className={styles.grid}>
                    {pagedData.length === 0 ? (
                        <div className={styles.empty}>게시물이 없습니다.</div>
                    ) : (
                        pagedData.map((item, i) => (
                            <div
                                className={styles.card}
                                key={item.id}
                                onClick={() => {
                                    // 타입에 따라 다른 경로로 이동
                                    if (activeTab === "notice") {
                                        navigate(`/news/notice/${item.id}`);
                                    } else if (activeTab === "press") {
                                        navigate(`/news/press/${item.id}`);
                                    } else if (activeTab === "seminar") {
                                        navigate(`/news/seminar/${item.id}`);
                                    }
                                }}
                                style={{ cursor: "pointer" }}
                            >
                                <img
                                    src={item.img}
                                    alt=""
                                    className={styles.cardImg}
                                />
                                <div className={styles.cardText}>
                                    <div className={styles.title}>
                                        {item.title}
                                    </div>
                                    <div className={styles.date}>
                                        {item.date}
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                    </div>
                </ScrollReveal>

                {/* 페이지네이션 */}
                {totalPages > 1 && (
                    <div className={styles.pagination}>
                        {[...Array(totalPages)].map((_, i) => (
                            <button
                                key={i}
                                className={`${styles.pageBtn} ${
                                    page === i + 1 ? styles.active : ""
                                }`}
                                onClick={() => setPage(i + 1)}
                                type="button"
                            >
                                {i + 1}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
